var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isVisible,
          expression: "isVisible",
        },
      ],
      staticClass: "comment-textarea mb-2",
    },
    [
      _c("label", { staticClass: "text-muted font-sm" }, [
        _vm._v(_vm._s(_vm.inputLabel)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "comment-input__editor",
          class: { "comment-input__editor--dragging": _vm.isDragging },
          on: {
            dragover: function ($event) {
              $event.preventDefault()
              _vm.isDragging = true
            },
            dragleave: function ($event) {
              $event.preventDefault()
              _vm.isDragging = false
            },
            drop: function ($event) {
              $event.preventDefault()
              return _vm.onDrop.apply(null, arguments)
            },
          },
        },
        [
          _c("RichTextEditor", {
            ref: "inputComment",
            attrs: {
              "allow-images": "",
              "allow-library-browse": false,
              placeholder: "Write a comment, or drop an image or video here",
            },
            on: {
              input: _vm.setCommentText,
              ready: _vm.onEditorReady,
              "pick-upload": _vm.pickInlineMedia,
            },
            model: {
              value: _vm.commentContent,
              callback: function ($$v) {
                _vm.commentContent = $$v
              },
              expression: "commentContent",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "comment-input__bar" }, [
            _c(
              "button",
              {
                staticClass: "comment-input__attach",
                attrs: { type: "button" },
                on: { click: _vm.pickFiles },
              },
              [
                _c("i", {
                  staticClass: "bi bi-paperclip comment-input__attach-icon",
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Attach files")]),
              ]
            ),
            _vm._v(" "),
            _vm.isUploading
              ? _c(
                  "span",
                  { staticClass: "comment-input__uploading" },
                  [
                    _c("b-spinner", { attrs: { small: "" } }),
                    _vm._v(" Uploading…\n      "),
                  ],
                  1
                )
              : _c("span", { staticClass: "comment-input__formats" }, [
                  _vm._v("images · video · .pdf · .docx"),
                ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.attachments.length
        ? _c(
            "div",
            { staticClass: "comment-input__chips mt-2" },
            _vm._l(_vm.attachments, function (item) {
              return _c(
                "span",
                { key: item.id, staticClass: "comment-input__chip" },
                [
                  _c("i", { class: ["bi", _vm.referenceChipIconClass(item)] }),
                  _vm._v(" "),
                  _c("span", { staticClass: "comment-input__chip-name" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "comment-input__chip-remove",
                      attrs: { type: "button", title: "Remove file" },
                      on: {
                        click: function ($event) {
                          return _vm.removeAttachment(item)
                        },
                      },
                    },
                    [_c("b-icon", { attrs: { icon: "x" } })],
                    1
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center my-1",
        },
        [
          _c(
            "div",
            [
              _c(
                "b-button-group",
                { attrs: { size: "sm" } },
                [
                  _vm.recording && !_vm.commentEditing
                    ? [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: {
                              variant: "outline-info cursor-pointer",
                              title: "Start screen recording",
                              disabled: _vm.recording.recordButtonDisabled,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.startRecording("screen")
                              },
                            },
                          },
                          [_c("b-icon", { attrs: { icon: "mic" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: {
                              variant: "outline-info cursor-pointer",
                              title: "Start recording",
                              disabled: _vm.recording.recordButtonDisabled,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.startRecording("video")
                              },
                            },
                          },
                          [_c("b-icon", { attrs: { icon: "camera-reels" } })],
                          1
                        ),
                        _vm._v(" "),
                        _vm.recording.saveVideoModel
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  variant: "outline-success cursor-pointer",
                                  title: "Upload video",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("submit-video")
                                  },
                                },
                              },
                              [_c("b-icon", { attrs: { icon: "upload" } })],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.recording.stopVideoModel
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  variant: "outline-danger cursor-pointer",
                                  title: "Stop recording",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("stop-recording")
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "stop-circle" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.recording.deleteVideoModel
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                attrs: {
                                  variant: "outline-danger cursor-pointer",
                                  title: "Delete video",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("delete-recording")
                                  },
                                },
                              },
                              [_c("b-icon", { attrs: { icon: "trash" } })],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: {
                        variant: "outline-primary",
                        title: "Save comment",
                        disabled: _vm.isSubmitting || _vm.isUploading,
                      },
                      on: { click: _vm.handleSubmit },
                    },
                    [
                      _vm.isSubmitting
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _c("b-icon", { attrs: { icon: "check2" } }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      attrs: {
                        variant: "outline-danger",
                        title: "Discard comment",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$root.$emit("close-comment")
                        },
                      },
                    },
                    [_c("b-icon", { attrs: { icon: "x", scale: "1.5" } })],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-checkbox",
            {
              attrs: { switch: "" },
              model: {
                value: _vm.isDraft,
                callback: function ($$v) {
                  _vm.isDraft = $$v
                },
                expression: "isDraft",
              },
            },
            [_vm._v("\n      Draft\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        staticClass: "d-none",
        attrs: { type: "file", multiple: "", accept: _vm.accept },
        on: { change: _vm.onFilesPicked },
      }),
      _vm._v(" "),
      _c("input", {
        ref: "inlineInput",
        staticClass: "d-none",
        attrs: { type: "file", multiple: "", accept: _vm.inlineAccept },
        on: { change: _vm.onInlineMediaPicked },
      }),
      _vm._v(" "),
      _vm.recording
        ? [
            _vm.recording.recordingTextModel
              ? _c(
                  "p",
                  {
                    class: _vm.recording.messageClass
                      ? "alert alert-success"
                      : "alert alert-danger",
                    attrs: { id: "recordingText" },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.recording.recordingText) +
                        "\n      "
                    ),
                    _vm.recording.recordTimer
                      ? _c("span", [_vm._v(_vm._s(_vm.recording.timer) + " s")])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "vidoe-container" }, [
              _vm.recording.startUpload
                ? _c("p", [_vm._v("\n        Uploading...\n      ")])
                : _vm._e(),
              _vm._v(" "),
              _vm.recording.videoUrl
                ? _c("video", {
                    staticClass: "float-right",
                    attrs: {
                      width: "200",
                      controls: "",
                      src: _vm.recording.videoUrl,
                    },
                  })
                : _vm._e(),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }